import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { axiosBase } from '@/api/api'
import { ElMessage } from 'element-plus'
export const useDataList = () => {
  const loading = ref(false);
  const totalParams = ref({})
  const route = useRoute()
  const listInfo = ref({
    pagesize: 20,
    curpage: 1,
    total: 0,
    list: []
  })
  const isNoList = ref(false)
  const handleListInfo = async (opt) => {
    const { pageId, key = '', query = {}, params = {}, ruledata = {}, currentPage = 1, pageSize = 20, id, powerData } = opt
    if (!id) return
    let api = ''
    loading.value = true
    totalParams.value = Object.assign(totalParams.value, {
      key,
      query,
      params,
      ruledata
    })
    let allParam = {}
    if (pageId === '1') {
      allParam = {
        type: 0,
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        key,
        query,
        reportFormId: powerData['0'].reportFormId,
        ...params,
        ...ruledata
      }
      api = '/api/getuserfielddatalist'
    } else if (pageId === '2') {
      // 带我处理
      allParam = {
        type: 1,
        status: '0',
        way: '0,1,2,4',
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        reportFormId: powerData['0'].reportFormId,
        key,
        query,
        ...params,
        ...ruledata
      }
      api = '/api/getuserfielddatalist'
    } else if (pageId === '3') {
      // 获取待阅的数据
      allParam = {
        type: 1,
        way: '0,1,2,4',
        status: '0',
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        key,
        ...query,
        ...params
      }
      api = '/openapi/getuserccapprovallist'
    } else if (pageId === '4') {
      // 获取我已处理的数据
      allParam = {
        type: 1,
        way: '0,1,2,4',
        status: '1,2',
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        reportFormId: powerData['0'].reportFormId,
        key,
        query,
        ...params,
        ...ruledata
      }
      api = '/api/getuserfielddatalist'
    } else if (pageId === '5') {
      allParam = {
        type: 0,
        selfuser: 0,
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        reportFormId: powerData['0'].reportFormId,
        key,
        query,
        ...params,
        ...ruledata
      }
      api = '/api/getuserfielddatalist'
    } else if (pageId === '6' || pageId === '7') {
      allParam = {
        type: 0,
        curpage: currentPage,
        pagesize: pageSize,
        approvalId: id,
        reportFormId: powerData['0'].reportFormId,
        key,
        query,
        ...params,
        ...ruledata
      }
      if (pageId === '6') {
        allParam.querys = query
        delete allParam.query
      }
      api = '/api/getfielddatalist'
    }
    if (route.query.spaceid) {
      allParam.spaceid = route.query.spaceid
    } else if (route.query.upaceid) {
      allParam.upaceid = route.query.upaceid
    }
    const res = await axiosBase(allParam, api)
    if (res.code === 0) {
      console.log(res.data,'asdasdasdsad')
      if (res.data.length === res.total) isNoList.value = true
      listInfo.value.curpage = res.curpage
      listInfo.value.pagesize = res.pagesize
      listInfo.value.total = res.total
      listInfo.value.list = dealReadNum(res.data)
    } else {
      if (res.code === -1) {
        ElMessage.error(res.msg)
        return
      }
    }
  }

  const dealReadNum = (data = []) => {
    return data.map(item => {
      const obj = {
        阅读数: (item.read || 0) + '',
        点赞数: (item.point || 0) + '',
        收藏数: (item.collect || 0) + '',
        转发数: (item.forward || 0) + ''
      }
      return { ...obj, ...item }
    })
  }
  return {
    handleListInfo,
    loading,
    listInfo,
    totalParams,
    isNoList
  }
}